export default {
    legalEntities: {
        list: [],
        availableCurrencies: [],
        availableLanguages: [],
        edit: { legalEntity: {} }
    }
};
